// Single source of truth for API/MCP scope metadata, shared by the
// API-key picker (pages/ApiKeys) and the connected-agents scope chips
// (pages/ConnectedApps) so a label can't drift between them.
//
// Only scopes an endpoint actually enforces are listed — offering a scope
// nothing checks is a silent no-op. ownership:read / bods:export /
// batch:write are intentionally absent until an endpoint or tool actually
// gates on them. Keep this in sync with what the worker enforces
// (index.ts /v1/*, routes/watch.ts, mcp/tools.ts) and with the worker's
// ASSIGNABLE_SCOPES (routes/admin.ts) / MCP_OAUTH_SCOPES (auth/principal.ts).
export interface ScopeMeta {
  id: string;
  label: string;
  description: string;
}

export const SCOPES: ScopeMeta[] = [
  {
    id: "screen:read",
    label: "Company lookups",
    description: "Look up companies and read source coverage.",
  },
  {
    id: "entities:read",
    label: "Entity & financial reads",
    description:
      "Search and read entity data — financials, filings, ownership signals — and view existing watchlists and their events.",
  },
  {
    id: "watch:manage",
    label: "Manage watchlists",
    description:
      "Create, test and remove watch subscriptions, including registering webhook delivery URLs.",
  },
];

// Raw scope id → human label. Unmapped scopes fall back to the raw id at
// the call site (`SCOPE_LABEL[s] ?? s`).
export const SCOPE_LABEL: Record<string, string> = Object.fromEntries(
  SCOPES.map((s) => [s.id, s.label]),
);
